import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  buildBookingDataFromVehicle,
  fetchPublicVehicles,
  groupVehiclesByTrip,
  toBookingTripLabel,
} from "../services/vehicleService";
import sedanImage from "../assets/Swift1.png";
import etiosImage from "../assets/etios-car.jpg";
import ertigaImage from "../assets/front-left-side-47.avif";
import crystaImage from "../assets/images.jpg";
import hycrossImage from "../assets/hycross.avif";
import fortunerImage from "../assets/fortunes.avif";
import tempoImage from "../assets/tempo.jpg";
import urbaniaImage from "../assets/Urbania8.png";
import innovaImage from "../assets/innovabase.avif";

const VOLVO_BUS_IMAGE_URL = "https://cdn.motorbazee.com/ImageData/model/800x600/195525.jpg";

const fleetImageMap = {
  sedan: sedanImage,
  hatchback: sedanImage,
  premiumSedan: etiosImage,
  ertiga: ertigaImage,
  innova: innovaImage,
  crysta: crystaImage,
  hycross: hycrossImage,
  fortuner: fortunerImage,
  tempo: tempoImage,
  Urbania: urbaniaImage,
  urbania: urbaniaImage,
  buss: VOLVO_BUS_IMAGE_URL,
  bus: VOLVO_BUS_IMAGE_URL,
};

const fleet = [
  {
    id: 2,
    image: "sedan",
    name: "Sedan",
    models: "Swift Dzire, Etios",
    type: "Comfort",
    seaters: 4,
    bags: 3,
    price: "₹12/km",
    per: null,
    tag: "Popular",
    badge: "popular",
    rating: 4.7,
    features: ["Spacious Boot", "Business Travel", "Smooth Ride"],
    category: "Sedan",
    color: "#FFC200",
    image: "https://dreamzyatra.com/best-car-rental-service-kolkata/assets/images/swift_dzire.webp",
    desc: "Comfortable sedan for business and airport travel.",
    seats: 4,
    luggage: 3,
    eta: "4 min",
    availableFor: ["airport", "outstation", "local"]
  },
  {
    id: 4,
    image: "suv",
    name: "Ertiga",
    models: "Ertiga, Innova",
    type: "Family",
    seaters: 7,
    bags: 4,
    price: "₹15/km",
    per: null,
    tag: "Best Value",
    badge: "value",
    rating: 4.6,
    features: ["Group Travel", "Extra Luggage", "3 Rows"],
    category: "SUV",
    color: "#FF8C00",
    image: "https://s3.ap-south-1.amazonaws.com/cb360static/uploads/61d3d0f9-ec26-4631-b526-f2046ea58e28-small-Maruti%20Ertiga%20Tour%20%281%29%20%281%29.avif",
    desc: "Spacious SUV perfect for family trips.",
    seats: 7,
    luggage: 4,
    eta: "5 min",
    availableFor: ["airport", "outstation", "local"]
  },
  {
    id: 5,
    image: "innova",
    name: "Innova Crysta",
    models: "Toyota Innova",
    type: "Premium SUV",
    seaters: 7,
    bags: 5,
    price: "₹19/km",
    per: null,
    tag: null,
    badge: null,
    rating: 4.9,
    features: ["Luxury Interior", "Captain Seats", "Premium AC"],
    category: "SUV",
    color: "#FFA500",
    image: "https://chybmedia.s3.ap-south-1.amazonaws.com/models/cars/innova-crysta-9-240.jpg",
    desc: "Premium SUV with luxurious interiors.",
    seats: 7,
    luggage: 5,
    eta: "5 min",
    availableFor: ["airport", "outstation", "local"]
  },
  {
    id: 6,
    image: "innova",
    name: "Innova Hybrid",
    models: "Innova Hycross",
    type: "Luxury",
    seaters: 7,
    bags: 5,
    price: "₹24/km",
    per: null,
    tag: "Top Pick",
    badge: "top",
    rating: 5.0,
    features: ["Hybrid Engine", "Panoramic Roof", "ADAS Safety"],
    category: "SUV",
    color: "#800080",
    image: "https://imgd.aeplcdn.com/1920x1080/n/cw/ec/115025/innova-hycross-exterior-right-front-three-quarter-72.jpeg?isig=0&q=80&q=80",
    desc: "Luxury hybrid SUV with advanced features.",
    seats: 7,
    luggage: 5,
    eta: "6 min",
    availableFor: ["airport", "outstation", "local"]
  },
  {
    id: 7,
    image: "innova",
    name: "Innova Hycross",
    models: "Innova Hycross",
    type: "Luxury",
    seaters: 7,
    bags: 5,
    price: "₹24/km",
    per: null,
    tag: "Top Pick",
    badge: "top",
    rating: 5.0,
    features: ["Hybrid Engine", "Panoramic Roof", "ADAS Safety"],
    category: "SUV",
    color: "#800080",
    image: "https://goldsun.in/wp-content/uploads/2023/08/innova-hycross-1-1024x694.png",
    desc: "Luxury hybrid SUV with advanced features.",
    seats: 7,
    luggage: 5,
    eta: "6 min",
    availableFor: ["airport", "outstation", "local"]
  },
  {
    id: 8,
    image: "tempo",
    name: "Tempo Traveller",
    models: "9 / 12 Seater",
    type: "Group",
    seaters: 12,
    bags: 8,
    price: "₹24/km",
    per: null,
    tag: null,
    badge: null,
    rating: 4.5,
    features: ["Pushback Seats", "Group Trips", "Large Luggage"],
    category: "Van",
    color: "#FF6B00",
    image: "https://saibabatravels.com/wp-content/uploads/2024/12/3.jpg",
    desc: "Perfect for group outings and events.",
    seats: 12,
    luggage: 8,
    eta: "8 min",
    availableFor: ["outstation", "airport"]
  },
  {
    id: 9,
    image: "bus",
    name: "Bus",
    models: "12–50 Seater",
    type: "Large Group",
    seaters: 50,
    bags: 20,
    price: "₹35/km",
    per: null,
    tag: null,
    badge: null,
    rating: 4.4,
    features: ["Restroom", "Luggage Bay", "Events & Tours"],
    category: "Van",
    color: "#4682B4",
    image: VOLVO_BUS_IMAGE_URL,
    desc: "Luxury bus for large groups and tours.",
    seats: 50,
    luggage: 20,
    eta: "10 min",
    availableFor: ["outstation"]
  },
];

const tagColors = {
  "Popular": { bg: "#FFF3E0", text: "#E65100" },
  "Most Booked": { bg: "#FFE0B2", text: "#BF360C" },
  "Best Value": { bg: "#C8E6C9", text: "#2E7D32" },
  "Top Pick": { bg: "#FFCDD2", text: "#B71C1C" },
  "Economy": { bg: "#FFF3CD", text: "#B8860B" },
  "Premium": { bg: "#FFE8CC", text: "#D2691E" },
  "Comfort": { bg: "#FFF9E6", text: "#CC8800" },
  "Group": { bg: "#E8F4FD", text: "#1E6B9E" },
  "Elite": { bg: "#2A2A2A", text: "#FFD700" },
  "Eco": { bg: "#E8F5E9", text: "#2E7D32" }
};

const getFleetKey = (car = {}) =>
  car.vehicleId || car.id || `${car.name || car.vehicleType || "vehicle"}-${car.image || ""}`;

export default function OurFleet() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedCar, setSelectedCar] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
  const [imageErrors, setImageErrors] = useState({});
  const [apiFleet, setApiFleet] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadVehicles = async () => {
      try {
        setIsLoading(true);
        setLoadError("");
        const vehicles = await fetchPublicVehicles();
        const grouped = groupVehiclesByTrip(vehicles);
        const uniqueVehicles = new Map();

        Object.entries(grouped).forEach(([trip, tripVehicles]) => {
          tripVehicles.forEach((vehicle) => {
            const key = getFleetKey(vehicle);
            if (!uniqueVehicles.has(key)) {
              uniqueVehicles.set(key, {
                ...vehicle,
                availableFor: vehicle.availableFor,
                defaultTrip: trip,
              });
            }
          });
        });

        if (isMounted) {
          setApiFleet(Array.from(uniqueVehicles.values()));
        }
      } catch (error) {
        if (isMounted) {
          setLoadError(error.message || "Unable to load vehicles");
          setApiFleet([]);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadVehicles();

    return () => {
      isMounted = false;
    };
  }, []);
  
  const filtered =
    activeCategory === "All"
      ? apiFleet
      : apiFleet.filter((c) => String(c.category || "").toLowerCase() === activeCategory.toLowerCase());
  const displayedCategories = [
    "All",
    ...Array.from(new Set(apiFleet.map((car) => car.category).filter(Boolean))),
  ];

  const handleBookNow = (car, e) => {
    e.stopPropagation();
    
    const trip = car.defaultTrip || car.availableFor?.[0] || "airport";
    const vehicleData = {
      ...car,
      category: car.category || car.type || trip,
    };
    const bookingData = buildBookingDataFromVehicle(vehicleData, trip);
    const defaultTripType = toBookingTripLabel(trip);
    
    navigate('/booking', {
      state: {
        selectedVehicleData: vehicleData,
        initialRouteData: bookingData,
        tripType: defaultTripType,
      },
    });
  };

  const handleCardClick = (car) => {
    setSelectedCar(car);
  };

  const handleImageError = (carId) => {
    setImageErrors(prev => ({ ...prev, [carId]: true }));
  };

  const getFallbackImage = (carName) => {
    return `https://via.placeholder.com/400x300/FFD700/000000?text=${encodeURIComponent(carName)}`;
  };

  const getImageSrc = (car) => {
    if (imageErrors[getFleetKey(car)]) return getFallbackImage(car.name);
    if (fleetImageMap[car.image]) return fleetImageMap[car.image];
    return String(car.image || "").startsWith("http") ? car.image : getFallbackImage(car.name);
  };

  // Get available trip types badges for a car
  const getTripTypeBadges = (car) => {
    const badges = [];
    if (car.availableFor.includes('airport')) badges.push({ bg: "#e6f0ff", text: "#1A73E8", label: "✈️ Airport" });
    if (car.availableFor.includes('outstation')) badges.push({ bg: "#fff0e6", text: "#FF6B35", label: "🌍 Outstation" });
    if (car.availableFor.includes('local')) badges.push({ bg: "#e6f5e6", text: "#0B8A4D", label: "🏠 Local" });
    return badges;
  };

  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerBadge}>Our Fleet</div>
        <h1 style={styles.title}>
          Choose Your
          <span style={styles.titleAccent}> Perfect Ride</span>
        </h1>
        <p style={styles.subtitle}>
          From budget-friendly rides to luxury experiences — we've got you covered
        </p>
      </div>

      {/* Category Filter */}
      <div style={styles.filterWrapper}>
        <div style={styles.filterScroll}>
          {displayedCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              style={{
                ...styles.filterBtn,
                ...(activeCategory === cat ? styles.filterBtnActive : {}),
              }}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Fleet Grid */}
      <div style={styles.grid}>
        {isLoading && (
          <div style={styles.emptyState}>Loading vehicles...</div>
        )}
        {!isLoading && loadError && (
          <div style={styles.emptyState}>{loadError}</div>
        )}
        {!isLoading && !loadError && filtered.length === 0 && (
          <div style={styles.emptyState}>No vehicles available for this selection.</div>
        )}
        {!isLoading && !loadError && filtered.map((car) => {
          const tag = car.tag && tagColors[car.tag] ? tagColors[car.tag] : { bg: "#E0E0E0", text: "#616161" };
          const isHovered = hoveredId === car.id;
          const tripBadges = getTripTypeBadges(car);
          
          return (
            <div
              key={getFleetKey(car)}
              style={{
                ...styles.card,
                ...(isHovered ? styles.cardHovered : {}),
              }}
              onMouseEnter={() => setHoveredId(car.id)}
              onMouseLeave={() => setHoveredId(null)}
              onClick={() => handleCardClick(car)}
            >
              {/* Card Top - Image Section */}
              <div
                style={{
                  ...styles.cardTop,
                  background: `linear-gradient(135deg, ${car.color}22 0%, #FFF8DC 100%)`,
                }}
              >
                <div style={styles.imageContainer}>
                  <img 
                    src={getImageSrc(car)} 
                    alt={car.name} 
                    style={styles.cardImage}
                    onError={() => handleImageError(getFleetKey(car))}
                  />
                </div>
                {car.tag && (
                  <span
                    style={{
                      ...styles.tag,
                      background: tag.bg,
                      color: tag.text,
                    }}
                  >
                    {car.tag}
                  </span>
                )}
              </div>

              {/* Card Body */}
              <div style={styles.cardBody}>
                <div style={styles.cardHeader}>
                  <div>
                    <h3 style={styles.carName}>{car.name}</h3>
                    <span style={styles.carCategory}>{car.type}</span>
                  </div>
                  <div style={styles.priceBox}>
                    <span style={styles.price}>{car.price}</span>
                  </div>
                </div>

                {/* Trip Type Badges */}
                <div style={styles.tripBadges}>
                  {tripBadges.map((badge, idx) => (
                    <span key={idx} style={{
                      background: badge.bg,
                      color: badge.text,
                      fontSize: "10px",
                      fontWeight: 700,
                      padding: "3px 8px",
                      borderRadius: "12px",
                      marginRight: "5px",
                      display: "inline-block",
                      marginBottom: "4px"
                    }}>
                      {badge.label}
                    </span>
                  ))}
                </div>

                <p style={styles.desc}>{car.desc}</p>

                {/* Stats Row */}
                <div style={styles.statsRow}>
                  <div style={styles.stat}>
                    <span style={styles.statIcon}>👥</span>
                    <span style={styles.statText}>{car.seats} seats</span>
                  </div>
                  <div style={styles.stat}>
                    <span style={styles.statIcon}>🧳</span>
                    <span style={styles.statText}>{car.luggage} bags</span>
                  </div>
                  <div style={styles.stat}>
                    <span style={styles.statIcon}>⏱️</span>
                    <span style={styles.statText}>{car.eta}</span>
                  </div>
                </div>

                {/* Features */}
                <div style={styles.features}>
                  {car.features.slice(0, 3).map((f) => (
                    <span key={f} style={styles.featureChip}>
                      ✓ {f}
                    </span>
                  ))}
                </div>

                <button 
                  style={styles.bookBtn}
                  onClick={(e) => handleBookNow(car, e)}
                >
                  Book {car.name.split(" ")[0]} →
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Details Modal */}
      {selectedCar && (
        <div style={styles.overlay} onClick={() => setSelectedCar(null)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <button style={styles.closeBtn} onClick={() => setSelectedCar(null)}>
              ✕
            </button>
            <div
              style={{
                ...styles.modalTop,
                background: `linear-gradient(135deg, ${selectedCar.color}33, #FFF8DC)`,
              }}
            >
              <div style={styles.modalImageContainer}>
                <img 
                  src={getImageSrc(selectedCar)} 
                  alt={selectedCar.name} 
                  style={styles.modalImage}
                  onError={() => handleImageError(getFleetKey(selectedCar))}
                />
              </div>
            </div>
            <div style={styles.modalBody}>
              <div style={styles.modalHeader}>
                <div>
                  <h2 style={styles.modalTitle}>{selectedCar.name}</h2>
                  <span style={styles.carCategory}>{selectedCar.type}</span>
                </div>
                <span style={styles.modalPrice}>{selectedCar.price}</span>
              </div>
              
              {/* Trip Type Badges in Modal */}
              <div style={styles.modalTripBadges}>
                {getTripTypeBadges(selectedCar).map((badge, idx) => (
                  <span key={idx} style={{
                    background: badge.bg,
                    color: badge.text,
                    fontSize: "11px",
                    fontWeight: 700,
                    padding: "4px 10px",
                    borderRadius: "16px",
                    marginRight: "8px",
                    display: "inline-block",
                    marginBottom: "4px"
                  }}>
                    {badge.label}
                  </span>
                ))}
              </div>

              <p style={styles.modalDesc}>{selectedCar.desc}</p>
              <div style={styles.statsRow}>
                <div style={styles.stat}>
                  <span style={styles.statIcon}>👥</span>
                  <span style={styles.statText}>{selectedCar.seats} Seats</span>
                </div>
                <div style={styles.stat}>
                  <span style={styles.statIcon}>🧳</span>
                  <span style={styles.statText}>{selectedCar.luggage} Bags</span>
                </div>
                <div style={styles.stat}>
                  <span style={styles.statIcon}>⏱️</span>
                  <span style={styles.statText}>{selectedCar.eta}</span>
                </div>
              </div>
              <div style={{ marginTop: 16 }}>
                <p style={styles.featureLabel}>Features Included</p>
                <div style={styles.features}>
                  {selectedCar.features.map((f) => (
                    <span key={f} style={styles.featureChip}>
                      ✓ {f}
                    </span>
                  ))}
                </div>
              </div>
              <button 
                style={styles.modalBookBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedCar(null);
                  handleBookNow(selectedCar, e);
                }}
              >
                Book Now →
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Nunito', sans-serif; }
        ::-webkit-scrollbar { height: 4px; }
        ::-webkit-scrollbar-thumb { background: #FFD700; border-radius: 4px; }

        @keyframes slideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }

        @media (max-width: 600px) {
          .fleet-grid { grid-template-columns: 1fr !important; }
        }
        @media (min-width: 601px) and (max-width: 900px) {
          .fleet-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>
    </div>
  );
}

// Updated styles with proper image containers
const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #FFFDF0 0%, #FFFFFF 100%)",
    fontFamily: "'Nunito', sans-serif",
    paddingBottom: 60,
  },
  header: {
    textAlign: "center",
    padding: "60px 20px 30px",
    maxWidth: 700,
    margin: "0 auto",
  },
  headerBadge: {
    display: "inline-block",
    background: "#FFD700",
    color: "#111",
    fontWeight: 700,
    fontSize: 13,
    padding: "6px 16px",
    borderRadius: 20,
    marginBottom: 16,
    letterSpacing: 1,
  },
  title: {
    fontFamily: "'Syne', sans-serif",
    fontSize: "clamp(28px, 6vw, 48px)",
    fontWeight: 800,
    color: "#111",
    lineHeight: 1.15,
    marginBottom: 14,
  },
  titleAccent: {
    color: "#FFB800",
  },
  subtitle: {
    color: "#666",
    fontSize: 16,
    lineHeight: 1.6,
  },
  filterWrapper: {
    padding: "0 16px 24px",
    maxWidth: 900,
    margin: "0 auto",
  },
  filterScroll: {
    display: "flex",
    gap: 10,
    overflowX: "auto",
    paddingBottom: 4,
    justifyContent: "center",
    flexWrap: "wrap",
  },
  filterBtn: {
    background: "#fff",
    border: "2px solid #E8E0C8",
    borderRadius: 24,
    padding: "8px 20px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    color: "#555",
    whiteSpace: "nowrap",
    transition: "all 0.2s",
    fontFamily: "'Nunito', sans-serif",
  },
  filterBtnActive: {
    background: "#FFD700",
    border: "2px solid #FFD700",
    color: "#111",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: 20,
    maxWidth: 1100,
    margin: "0 auto",
    padding: "0 16px",
  },
  emptyState: {
    gridColumn: "1 / -1",
    background: "#fff",
    border: "1.5px solid #F0E8C8",
    borderRadius: 16,
    color: "#666",
    fontWeight: 700,
    padding: "28px 20px",
    textAlign: "center",
  },
  card: {
    background: "#FFFFFF",
    borderRadius: 20,
    overflow: "hidden",
    boxShadow: "0 4px 20px rgba(0,0,0,0.07)",
    cursor: "pointer",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    border: "1.5px solid #F0E8C8",
  },
  cardHovered: {
    transform: "translateY(-6px)",
    boxShadow: "0 12px 40px rgba(255,200,0,0.2)",
    border: "1.5px solid #FFD700",
  },
  cardTop: {
    height: 160,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    padding: "10px",
  },
  imageContainer: {
    width: "100%",
    height: "140px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    borderRadius: "12px",
  },
  cardImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "12px",
    transition: "transform 0.3s ease",
  },
  tag: {
    position: "absolute",
    top: 12,
    right: 12,
    fontSize: 11,
    fontWeight: 700,
    padding: "4px 10px",
    borderRadius: 12,
    letterSpacing: 0.5,
    zIndex: 10,
  },
  cardBody: {
    padding: "18px 20px 20px",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 8,
  },
  carName: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 18,
    fontWeight: 700,
    color: "#111",
  },
  carCategory: {
    fontSize: 12,
    color: "#999",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 1,
  },
  priceBox: {
    background: "#FFF9E0",
    border: "1px solid #FFE066",
    borderRadius: 10,
    padding: "4px 10px",
  },
  price: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 15,
    fontWeight: 800,
    color: "#CC8800",
  },
  tripBadges: {
    marginBottom: 8,
  },
  desc: {
    fontSize: 13,
    color: "#777",
    lineHeight: 1.5,
    marginBottom: 14,
  },
  statsRow: {
    display: "flex",
    gap: 16,
    marginBottom: 14,
  },
  stat: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  statIcon: {
    fontSize: 14,
  },
  statText: {
    fontSize: 12,
    color: "#555",
    fontWeight: 600,
  },
  features: {
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
    marginBottom: 16,
  },
  featureChip: {
    background: "#FFFBEA",
    border: "1px solid #FFE680",
    color: "#AA7700",
    fontSize: 11,
    fontWeight: 700,
    padding: "3px 10px",
    borderRadius: 20,
  },
  featureLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: "#888",
    textTransform: "uppercase",
    letterSpacing: 1,
    marginBottom: 8,
  },
  bookBtn: {
    width: "100%",
    background: "linear-gradient(135deg, #FFD700, #FF8C00)",
    border: "none",
    borderRadius: 12,
    padding: "12px",
    fontSize: 14,
    fontWeight: 700,
    color: "#111",
    cursor: "pointer",
    fontFamily: "'Nunito', sans-serif",
    letterSpacing: 0.5,
    transition: "opacity 0.2s",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    zIndex: 1000,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  modal: {
    background: "#fff",
    borderRadius: "24px 24px 0 0",
    width: "100%",
    maxWidth: 480,
    maxHeight: "90vh",
    overflowY: "auto",
    position: "relative",
    animation: "slideUp 0.3s ease",
  },
  closeBtn: {
    position: "absolute",
    top: 14,
    right: 16,
    background: "rgba(255,255,255,0.9)",
    border: "none",
    width: 32,
    height: 32,
    borderRadius: "50%",
    fontSize: 14,
    cursor: "pointer",
    fontWeight: 700,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  },
  modalTop: {
    height: 180,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "24px 24px 0 0",
    padding: "15px",
  },
  modalImageContainer: {
    width: "100%",
    height: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    borderRadius: "12px",
  },
  modalImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "12px",
  },
  modalBody: {
    padding: "20px 24px 32px",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 10,
  },
  modalTitle: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 22,
    fontWeight: 800,
    color: "#111",
  },
  modalPrice: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 20,
    fontWeight: 800,
    color: "#CC8800",
    background: "#FFF9E0",
    padding: "6px 14px",
    borderRadius: 12,
    border: "1px solid #FFE066",
  },
  modalTripBadges: {
    marginBottom: 12,
  },
  modalDesc: {
    fontSize: 14,
    color: "#666",
    lineHeight: 1.6,
    marginBottom: 16,
  },
  modalBookBtn: {
    width: "100%",
    background: "linear-gradient(135deg, #FFD700, #FF8C00)",
    border: "none",
    borderRadius: 14,
    padding: "16px",
    fontSize: 16,
    fontWeight: 800,
    color: "#111",
    cursor: "pointer",
    fontFamily: "'Nunito', sans-serif",
    marginTop: 20,
    letterSpacing: 0.5,
  },
};
